import React, { useEffect, useState } from 'react';
import { Button, Confirm, Form, Header, Message, Select } from 'semantic-ui-react';
import { API, showError, showSuccess } from '../helpers';

const invoiceTypeOptions = [
  { key: 1, value: 1, text: '普通发票' },
  { key: 2, value: 2, text: '增值税专用发票' },
];

const InvoiceProfile = () => {
  const [type, setType] = useState(1);
  const [title, setTitle] = useState('');
  const [taxNumber, setTaxNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [saved, setSaved] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    API.get('/api/invoice/profile')
      .then((res) => {
        const { success, data } = res.data;
        if (success && data) {
          setType(data.type || 1);
          setTitle(data.title || '');
          setTaxNumber(data.tax_number || '');
          if (data.title && data.tax_number) {
            setSaved(true);
          }
        }
      })
      .catch(() => {})
      .finally(() => setFetching(false));
  }, []);

  const handleSaveClick = () => {
    if (!title.trim() || !taxNumber.trim()) {
      showError('发票抬头和税号不能为空');
      return;
    }
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    setConfirmOpen(false);
    setLoading(true);
    try {
      const res = await API.put('/api/invoice/profile', {
        type,
        title: title.trim(),
        tax_number: taxNumber.trim(),
      });
      const { success, message } = res.data;
      if (success) {
        showSuccess('发票信息已保存');
        setSaved(true);
      } else {
        showError(message);
      }
    } catch (_) {
      showError('保存失败');
    } finally {
      setLoading(false);
    }
  };

  if (fetching) return null;

  return (
    <div>
      <Header as='h3'>发票信息</Header>
      <Message warning size='small'>
        发票抬头设置后不支持修改，如需修改，请联系管理员。
      </Message>
      <Form>
        <Form.Field>
          <label>发票类型</label>
          <Select
            options={invoiceTypeOptions}
            value={type}
            onChange={(e, { value }) => setType(value)}
            disabled={saved}
          />
        </Form.Field>
        <Form.Field>
          <label>发票抬头</label>
          <Form.Input
            placeholder='公司名称'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            disabled={saved}
          />
        </Form.Field>
        <Form.Field>
          <label>纳税人识别号</label>
          <Form.Input
            placeholder='税号'
            value={taxNumber}
            onChange={(e) => setTaxNumber(e.target.value)}
            disabled={saved}
          />
        </Form.Field>
        {!saved && (
          <Button primary onClick={handleSaveClick} loading={loading} disabled={loading}>
            保存
          </Button>
        )}
      </Form>
      <Confirm
        open={confirmOpen}
        content='发票抬头设置后不支持修改，确认保存？'
        confirmButton='确认'
        cancelButton='取消'
        onCancel={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
};

export default InvoiceProfile;
